export default __webpack_public_path__ + "static/media/b-5.a61c5470.png";